<template>
  <transition name="animation-fade-up">
    <CompactPlayer v-if="isPanelOpen && isAdaptive" />
  </transition>
</template>

<script setup>
  import { useAudioplayerAdaptiveMode } from '@/Groups/Audioplayer/private/composables/adaptiveModeControl';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  //-------------------------
  import CompactPlayer from '@/Groups/Audioplayer/private/core/CompactPlayer/CompactPlayer.vue';
  //-------------------------
  const { isPanelOpen } = useAudioPlayerState();
  //-------------------------
  const { isAdaptive } = useAudioplayerAdaptiveMode();
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>